import { RestClient } from '@/api/rest-client'
import { Referral } from '@/api/model/referral'
import { ReferralCount} from '@/api/model/referral-count'

export class ReferralCountClient extends RestClient<Referral> {
    collectionName = 'referrals'

    async getReferralCount(myLeads: boolean, assignedLeads: boolean, selectedTeam: string|null): Promise<ReferralCount> {
        const response = await this.client.post(`${this.basePath}/${this.collectionName}/count`, {
            owner: myLeads ? 'user' : 'team',
            type: assignedLeads ? 'assigned' : 'created',
            selectedTeam,
        })

        return ReferralCount.fromData(response.data)
    }
}
